import React, {Fragment,useState,useEffect,useRef,Suspense} from 'react';
import {Row, Col,
  Card, CardBody,
  CardTitle,Button,Form,Label,Input } from 'reactstrap';

import FormGridFormRow from '../SchedaIscritto/FormGridFormRow';

import TrasformaDateAUmano from '../TrasformaDateAUmano.js';

import Clessidra from '../Clessidra.js';

//import html2pdf from 'html2pdf.js';//per estrazione pdf

import Parametri from '../../parametri';
import TendinaEditabile from '../TendinaEditabile.js';

import { Page, Text, View, Document, StyleSheet,Image } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import styles from '../stiliPdf.js';

let larghColonna = 2;
let larghColonnaStretta = 1;

const STATO_INDEFINITO = 0;
const STATO_RICERCA_DATI = 1;
const STATO_OPERAZIONE_CORRETTA= 2;
const STATO_ERRORE_CONNESSIONE= 3;
const STATO_RICERCA_DATI_DETTAGLIO= 5;
//const STATO_VAI_IN_INSERISCI= 6;
//const STATO_OPERAZIONE_CORRETTA2= 7;

const STATO_SCARICA_PDF = 9;

function TabellaElencoPrenotazioni(props) {

    var today = new Date();
    let sMese = String(today.getMonth()+1);
    if(sMese.length === 1) sMese = "0"+sMese;
    let sGiorno = String(today.getDate());
    if(sGiorno.length === 1) sGiorno = "0"+sGiorno;

    const dataOggi = today.getFullYear()+'-'+sMese+'-'+sGiorno

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [variazioneCampi,setVariazioneCampi]=useState(0);
   
    const [statoTendinaIscritto,setStatoTendinaIscritto]=useState(false);
    const [statoTendinaPrestazione,setStatoTendinaPrestazione]=useState(false);
    const [risultatoServerDatiPersona,setRisultatoServerDatiPersona]=useState('');
    const [risultatoServerDatiPrestazioni,setRisultatoServerDatiPrestazioni]=useState('');
    const [risultatoPrenotazioni,setRisultatoPrenotazioni]=useState('');
    
    const [insPrestazioneEdi,setInsPrestazioneEdi]=useState('');
    const [insIdPrestazioneEdi,setInsIdPrestazioneEdi]=useState('');

    const [insPersonaEdi,setInsPersonaEdi]=useState('');
    const [insIdPersonaEdi,setInsIdPersonaEdi]=useState('');

    const [defaultPrestazione,setDefaultPrestazione]=useState('');
    const [defaultPersona,setDefaultPersona]=useState('');

    const [error,setError]=useState('');

    const  dataPartenza = useRef();
    const  dataArrivo = useRef();
    const [dataPartenzaDefault,setDataPartenzaDefault]=useState('');
    const [dataArrivoDefault,setDataArrivoDefault]=useState('');

    const [loading,setLoading]= useState(false);

    const [calcola,setCalcola]=useState(false);
    const [visualizza,setVisualizza]=useState(false);
    const [visualizzaInPdf,setVisualizzaInPdf]=useState(false);

    const [risultatiCognome,setRisultatiCognome]=useState([]);
    const [risultatiNome,setRisultatiNome]=useState([]);
    const [risultatiTessera,setRisultatiTessera]=useState([]);
    const [risultatiDescrizione,setRisultatiDescrizione]=useState([]);
    const [risultatiDa,setRisultatiDa]=useState([]);
    const [risultatiA,setRisultatiA]=useState([]);

    //per il logo:
    const [ricercaLogo,setRicercaLogo]=useState('');
    const [fileLogo,setFileLogo]=useState('');
    const [typeLogo,setTypeLogo]=useState('');
    const [nomeSocieta,setNomeSocieta]=useState('');
    const [capSocieta,setCapSocieta]=useState('');
    const [cittaSocieta,setCittaSocieta]=useState('');
    const [indirizzoSocieta,setIndirizzoSocieta]=useState('');
    const [pIvaSocieta,setPIvaSocieta]=useState('');
    const [codiceFiscaleSocieta,setCodiceFiscaleSocieta]=useState('');

    //var MyDocument = '';
    var elem = document.getElementById("cont");
    const [larghezzaPdf,setLarghezzaPdf] = useState(0);
    
    useEffect(() => {
      if(elem) setLarghezzaPdf(elem.getBoundingClientRect().width); 
    },[elem]);

    useEffect(() => {
      setStatoTendinaIscritto(false);
      ricercaDatiPersona();
      setDefaultPrestazione("Tutti");
      setDefaultPersona("Tutti");
      scaricaLogo();
    },[]);
 
    useEffect(() => {
      setVisualizza(false);
      setCalcola(false);
    },[insPersonaEdi,insPrestazioneEdi,dataPartenzaDefault,dataArrivoDefault]);

    useEffect(() => {
      if(calcola === true){
        ricercaDatiPrenotazioni();
      }
    },[calcola]);

    useEffect(() => {
      if(visualizzaInPdf === true) {
        //handleEsportaPDF();
        setStatoPagina(STATO_SCARICA_PDF);
      }
    },[visualizzaInPdf]);

    useEffect(() => {
      if(statoTendinaPrestazione === true && statoTendinaIscritto === true  && ricercaLogo === 1){
        setStatoPagina(STATO_OPERAZIONE_CORRETTA);
      }
    },[statoTendinaIscritto,statoTendinaPrestazione,ricercaLogo]);

    //funzioni:
    function ricercaDatiPrenotazioni(){
      //ricerco le prenotazioni già in calendario per la persona in esame:
      setLoading(true);
      let dataP = '';
      let dataA = '';
      if(dataPartenza.current) dataP = dataPartenza.current.value;
      if(dataArrivo.current) dataA = dataArrivo.current.value;
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"reportElencoPrenotazioni",
          idPersona:insIdPersonaEdi,
          idCorso:insIdPrestazioneEdi,
          dataInizio:dataP,
          dataFine:dataA,
          emak: props.emak,
          sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {
              setLoading(false);
              if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                  alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                        let arrLocale1=[];//cognome
                        let arrLocale2=[];//nome
                        let arrLocale3=[];//tessera
                        let arrLocale4=[];//prestazione
                        let arrLocale5=[];//data inizio
                        let arrLocale6=[];//data fine

                        for (let i=0; i<valoreDiRitorno.risultatoRitorno.length ; i++) {
                          arrLocale1[i]=valoreDiRitorno.risultatoRitorno[i].COGNOME;
                          arrLocale2[i]=valoreDiRitorno.risultatoRitorno[i].NOME;
                          arrLocale3[i]=valoreDiRitorno.risultatoRitorno[i].NUMERO_TESSERA;
                          arrLocale4[i]=valoreDiRitorno.risultatoRitorno[i].DESCRIZIONE;
                          arrLocale5[i]=valoreDiRitorno.risultatoRitorno[i].DATA_INIZIO;
                          arrLocale6[i]=valoreDiRitorno.risultatoRitorno[i].DATA_FINE;
                        }

                        setRisultatiCognome(arrLocale1);
                        setRisultatiNome(arrLocale2);
                        setRisultatiTessera(arrLocale3);
                        setRisultatiDescrizione(arrLocale4);
                        setRisultatiDa(arrLocale5);
                        setRisultatiA(arrLocale6);
                        setRisultatoPrenotazioni(valoreDiRitorno.risultatoRitorno);
                        setVisualizza(true);
                        
                      //setStatoPagina(STATO_OPERAZIONE_CORRETTA);
                }
          },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
  }
  function scaricaLogo() {
    setLoading(true);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({op:"ricercaLogo", emak: props.emak,sessionId: props.sessionId})
    };

    fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
      .then(risposta => risposta.json())
      .then(
      (valoreDiRitorno) => {     
        setLoading(false);     
          if(valoreDiRitorno.risultatoOperazione===1){
              if (valoreDiRitorno.risultatoRitorno[0].FILE !== undefined) {
                setFileLogo(valoreDiRitorno.risultatoRitorno[0].FILE);
                setTypeLogo(valoreDiRitorno.risultatoRitorno[0].TYPE);
                setNomeSocieta(valoreDiRitorno.risultatoRitorno[0].NOME);
                setCapSocieta(valoreDiRitorno.risultatoRitorno[0].CAP);
                setCittaSocieta(valoreDiRitorno.risultatoRitorno[0].CITTA);
                setIndirizzoSocieta(valoreDiRitorno.risultatoRitorno[0].INDIRIZZO);
                setPIvaSocieta(valoreDiRitorno.risultatoRitorno[0].PIVA);
                setCodiceFiscaleSocieta(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE);
              }
              setRicercaLogo(1);
          }
      },
      (error) => {console.log("Errore connessione");}
    );        
  }


    function ricercaDatiPersona() {
      //ricerco tra gli iscritti che mi servono per popolare la tendina delle persone che possono prenotare un corso:
      setLoading(true);
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"elencoPersone",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
      };
  
      fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {
              setLoading(false);
              if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                  alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
              setRisultatoServerDatiPersona(valoreDiRitorno.risultatoRitorno);
              setStatoTendinaIscritto(true);
              ricercaDatiPrestazioni();
              }
          },
          (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
          );
    }
    function ricercaDatiPrestazioni() {
        //ricerco tra i corsi che mi servono per popolare la tendina ed avere quando è attivo:
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoCorsi",emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
              setLoading(false);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                  }
                  if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                  if(valoreDiRitorno.risultatoOperazione===1){
                        setRisultatoServerDatiPrestazioni(valoreDiRitorno.risultatoRitorno);
                        setStatoTendinaPrestazione(true);
                        setCalcola(false);
                  }
            },
            (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function callbackSetVariazioneCampi(variazioneCampi){
      setVariazioneCampi(variazioneCampi);
    }
    function callbackSetValoreTendEditabilePersona(valore,pos,valoreNonVisibile){

        setInsPersonaEdi(valore);
        setInsIdPersonaEdi(valoreNonVisibile);
    }
    function callbackSetValoreTendEditabilePrestazione(valore,pos,valoreNonVisibile){

        setInsPrestazioneEdi(valore);
        setInsIdPrestazioneEdi(valoreNonVisibile);
    }
    //fine funzioni

    function callbackTermineModifica() {
      setStatoPagina(STATO_RICERCA_DATI);
    }

  return (
    <div id="cont" style={{minHeight: "100%",backgroundColor:"#F2F2F2"}}><Clessidra loading={loading}/>
     
  {statoPagina === STATO_SCARICA_PDF ? 
      <div>
      {/*<PDFViewer style={styles.viewer}>*/}
      <div style={{height: props.dimensioniApp.yMain,width: larghezzaPdf,display:"flex"}}><Clessidra loading={true}/></div>
      <PDFViewer style={{height: props.dimensioniApp.yMain,width: larghezzaPdf ,display:"flex", flexDirection:"column",backgroundColor:"transparent",position:"absolute",top:props.dimensioniApp.yTitolo}}>
    
        <Document>
          {/*<Page orientation="landscape" size="A4" style={styles.page}>*/}
          <Page size="A4" style={styles.page}>
            <View style={{width:"100%"}} >
              <View style={styles.tableIntestazione}> {/*apre table intestazione*/}
                      <View wrap={false} style={styles.tableRowIntestazione}> 
                        <View style={styles.tableColIntestazioneSx}> 
                          <View style={styles.tableCell}> 
                            {fileLogo !== "" ? <Image style={styles.logo} src={"data:" + typeLogo + ";base64," + fileLogo} />:<Text></Text>}                                    
                          </View> 
                        </View> 
                      <View style={styles.tableColIntestazioneDx}>   
                        <View style={styles.tableCellIntestazione}> 
                          {nomeSocieta !== "" ?<Text style={styles.nomesocieta}>{nomeSocieta}</Text>:<Text></Text>}
                          {indirizzoSocieta !== "" ?
                          <Text style={styles.datisocieta}>{indirizzoSocieta}
                          {cittaSocieta !== "" ?
                            capSocieta !== "" ?
                              " "+capSocieta+" "+cittaSocieta
                            :" "+cittaSocieta
                          :""}
                          </Text>
                          :<Text></Text>}
                          {pIvaSocieta !== "" ?<Text style={styles.datisocieta}>Partita IVA: {pIvaSocieta}</Text>:<Text></Text>}
                          {codiceFiscaleSocieta !== "" ?<Text style={styles.datisocieta}>Codice Fiscale: {codiceFiscaleSocieta}</Text>:<Text></Text>}
                                                
                          <Text style={styles.titolo}>Elenco Prenotazioni</Text>
                         
                      </View> 
                    </View> 
                    </View> 
                  </View> {/*chiude table intestazione*/}

                  <View>
                    <Text style={styles.titoloPiccolo}>Report del <TrasformaDateAUmano data={dataOggi}></TrasformaDateAUmano></Text>
                  </View>
                  <View wrap={false}> 
                      {insIdPersonaEdi !=='' ?
                        <View>
                          <Text style={styles.titoloPiccolo}>Iscritto: {insPersonaEdi}</Text>
                        </View>
                      :""}
                      {insIdPrestazioneEdi !==''?
                        <View>
                          <Text style={styles.titoloPiccolo}>Prestazione / Attrezzatura: {insPrestazioneEdi}</Text>
                        </View>
                      :""}
                      {dataPartenza.current && dataPartenza.current.value!==''?
                        <View>
                          <Text style={styles.titoloPiccolo}>Inizio Periodo di Analisi: <TrasformaDateAUmano data={dataPartenza.current.value}></TrasformaDateAUmano></Text>
                        </View>
                      :""}
                      {dataArrivo.current && dataArrivo.current.value!=='' ?
                        <View>
                          <Text style={styles.titoloPiccolo}>Fine Periodo di Analisi: <TrasformaDateAUmano data={dataArrivo.current.value}></TrasformaDateAUmano></Text>
                        </View>
                      :""}   
                    </View> 

                <View style={styles.table}>
                  <View wrap={false} style={styles.tableRowBlu}>
                          <View style={styles.tableCol5Di100}> 
                            <Text style={styles.tableCellGrassettoAllineatoSinistra}></Text> 
                          </View>  
                          <View style={styles.tableCol20Di100}> 
                            <Text style={styles.tableCellGrassettoAllineatoSinistra}>Cognome</Text> 
                          </View> 
                            <View style={styles.tableCol15Di100}> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistra}>Nome</Text> 
                            </View>
                            <View style={styles.tableCol15Di100}> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistra}>N.Tessera</Text> 
                            </View> 
                            <View style={styles.tableCol25Di100}> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistra}>Prestazione</Text> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistraNoBorderTop}>Attrezzatura</Text> 
                            </View> 
                            <View style={styles.tableCol10Di100}> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistra}>Data</Text> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistraNoBorderTop}>Inizio</Text>  
                              {/*<Text style={styles.tableCellGrassettoAllineatoSinistraNoBorderTop}>Prenotazione</Text>*/} 
                            </View> 
                            <View style={styles.tableCol10Di100}> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistra}>Data</Text> 
                              <Text style={styles.tableCellGrassettoAllineatoSinistraNoBorderTop}>Fine</Text>  
                              {/*<Text style={styles.tableCellGrassettoAllineatoSinistraNoBorderTop}>Prenotazione</Text>*/} 
                            </View> 
                      </View>

                  {risultatiDescrizione.map((elemento,index) => <View style={styles.tableRow} wrap={false} key={index}>

                    <View style={styles.tableCol5Di100}>
                    <Text style={styles.tableCell}> {index+1}</Text>
                  </View>                 
                  <View style={styles.tableCol20Di100}>
                    <Text style={styles.tableCellAllineatoSinistra}> {risultatiCognome[index]}</Text>
                  </View>
                  <View style={styles.tableCol15Di100}>
                    <Text style={styles.tableCellAllineatoSinistra}> {risultatiNome[index]}</Text>
                  </View>
                  <View style={styles.tableCol15Di100}>
                    <Text style={styles.tableCellAllineatoSinistra}> {risultatiTessera[index]}</Text>
                  </View>                       
                  <View style={styles.tableCol25Di100}>
                    <Text style={styles.tableCellAllineatoSinistra}> {risultatiDescrizione[index]}</Text>
                  </View>
                  <View style={styles.tableCol10Di100}>
                    <Text style={styles.tableCellAllineatoSinistra}> <TrasformaDateAUmano data={risultatiDa[index].split('T')[0]}></TrasformaDateAUmano> {risultatiDa[index].split('T')[1]}</Text>
                  </View>
                  <View style={styles.tableCol10Di100}>
                    <Text style={styles.tableCellAllineatoSinistra}> <TrasformaDateAUmano data={risultatiA[index].split('T')[0]}></TrasformaDateAUmano> {risultatiA[index].split('T')[1]}</Text>
                  </View>
                  </View>)}
       
                  </View>
              </View>
              <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
            </Page>
          </Document>
      </PDFViewer>
    </div>

    :""}


      {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1E_R_ElePren</div> :""}  
      {statoPagina === STATO_RICERCA_DATI || statoPagina === STATO_RICERCA_DATI_DETTAGLIO ? <Card className="main-card mb-3"><Clessidra loading={true}/></Card> :""}

      {statoPagina === STATO_OPERAZIONE_CORRETTA ?
        
        <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
            
            
            <Row>
              <Col lg="12">
                  <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                      {visualizzaInPdf === true ?
                        <div id='idDivGenerazionePdf' style={{display:'none'}}>Generazione PDF in corso...</div>
                      :""}

                            <CardTitle id="titolo">Elenco Prenotazioni</CardTitle>
                           
                                <Row form>  
                                <Col md={3}>    
                                <Label for="iscritto">Iscritto</Label>         
                                <TendinaEditabile
                                    //titolo={"Iscritto"}
                                    nomeCampo="COGNOME"
                                    nomeCampo2="NOME"
                                    nomeCampoParentesi="NUMERO_TESSERA"
                                    nomeCampoNonVisibile="ID"
                                    bloccoInserimento = "1"
                                    valoreDefault={defaultPersona}
                                    arrayValori={risultatoServerDatiPersona}
                                    inserisciCampoTutti = "1"
                                    callbackSetVariazioneCampi={callbackSetVariazioneCampi}
                                    callbackSetValoreTendEditabile={callbackSetValoreTendEditabilePersona}
                                ></TendinaEditabile>
                                </Col>       
                                <Col md={3}>
                                <Label for="corso">Prestazione / Attrezzatura</Label>
                                <TendinaEditabile
                                    nomeCampo="NOME"
                                    nomeCampoNonVisibile="ID"
                                    bloccoInserimento = "1"
                                    valoreDefault={defaultPrestazione}
                                    arrayValori={risultatoServerDatiPrestazioni}
                                    inserisciCampoTutti = "1"
                                    callbackSetVariazioneCampi={callbackSetVariazioneCampi}
                                    callbackSetValoreTendEditabile={callbackSetValoreTendEditabilePrestazione}
                                ></TendinaEditabile>
                                </Col>
                                
                                <Col md={2}>
                                <Label>Inizio Periodo di Analisi</Label>
                                <Input type="date" name="dataPartenza" id="dataPartenza"  defaultValue={dataPartenzaDefault} innerRef={dataPartenza}
                                    placeholder="" onInput={(e)=>{setDataPartenzaDefault(dataPartenza.current.value)}}/> 
                                </Col>
                                <Col md={2}>
                                <Label>Fine Periodo di Analisi</Label>
                                <Input type="date" name="dataArrivo" id="dataArrivo"  defaultValue={dataArrivoDefault} innerRef={dataArrivo}
                                placeholder="" onInput={(e)=>{setDataArrivoDefault(dataArrivo.current.value)}}/> 
                                </Col>
                                {visualizza !== true ?
                                  <Col md={2}>
                                    <div style={{paddingTop:24}}> 
                                      <Button color="success" className="mt-2" onClick={() => {setCalcola(true);setVisualizzaInPdf(false)}}>Calcola</Button>
                                    </div> 
                                  </Col>
                                : 
                                <Col md={2}>
                                    <div style={{paddingTop:24}}> 
                                      <Button color="success" className="mt-2" onClick={(e)=>{setVisualizzaInPdf(true)}}>Esporta il PDF</Button>
                                    </div> 
                                </Col>
                                }
                                </Row>
                              

                            <div id="dettaglioReport">
                            {visualizza === true ?
                              risultatoPrenotazioni.length === 0 ?
                                <Fragment >
                                  <Row form className="border">
                                  <Col md='12'><b>Non risultano prenotazioni che soddisfino le condizioni impostate</b></Col>
                                  </Row>
                                </Fragment>
                              :
                              
                              <Fragment>
                              
                              <Row form style={{marginTop:10, marginBottom:10}}> 
                                <Col>  
                                  <b>Report del <TrasformaDateAUmano data={dataOggi}></TrasformaDateAUmano></b>
                                </Col> 
                              </Row>  
                              
                              <Row form className="rigaTitoloTabellaReport">
                                <Col md={larghColonnaStretta} className="titoloTabellaReport"><b></b></Col>
                                <Col md={larghColonna} className="titoloTabellaReport">Cognome</Col>
                                <Col md={larghColonna} className="titoloTabellaReport">Nome</Col>
                                <Col md={larghColonnaStretta} className="titoloTabellaReport">Numero Tessera</Col>
                                

                                <Col md={larghColonna} className="titoloTabellaReport">Prestazione / Attrezzatura</Col>
                                <Col md={larghColonna} className="titoloTabellaReport">Data Inizio Prenotazione</Col>
                                <Col md={larghColonna} className="titoloTabellaReport">Data Fine Prenotazione</Col>
                              </Row>

              
                              {risultatiDescrizione.map((elemento,index) => <Row className="rigaTabellaReport" key={index}>

                                  <Col md={larghColonnaStretta}><center>{index+1}</center></Col>
                                  <Col md={larghColonna}>{risultatiCognome[index]}</Col>
                                  <Col md={larghColonna}>{risultatiNome[index]}</Col>
                                  <Col md={larghColonnaStretta}>{risultatiTessera[index]}</Col>
                                
                                <Col md={larghColonna}>{risultatiDescrizione[index]}</Col>
                                <Col md={larghColonna}><TrasformaDateAUmano data={risultatiDa[index].split('T')[0]}></TrasformaDateAUmano> {risultatiDa[index].split('T')[1]}</Col>
                                <Col md={larghColonna}><TrasformaDateAUmano data={risultatiA[index].split('T')[0]}></TrasformaDateAUmano> {risultatiA[index].split('T')[1]}</Col>
                              </Row>)}
                              </Fragment>
                            :""}
                        </div>                            
                      
                    </div>
                </Col>
            </Row>
        </div>
      :""}
    </div>
   );
}
export default TabellaElencoPrenotazioni;